
export default (api) => ({
  getCategories: (parentId)=> api.get('kaufland/categories/', {params:{parentId}}),
  getCategory:(categoryId) => api.get(`kaufland/categories/${categoryId}/`),
})
